import * as React from 'react';
import NAVector from 'assets/images/na-perdiem-vector.svg';
import { MessageCard } from './MessageCard';

interface Props {
  className?: string;
}

export const NoData: React.FC<Props> = (props) => {
  return (
    <MessageCard
      className={props.className}
      iconography={<img src={NAVector} alt="Empty State" />}
      title="Required data not available"
      description={
        <p>
          Some data required by the Smart Per Diem™ dispute tool is not currently available for this
          shipment. Please check back again soon.
        </p>
      }
    />
  );
};
NoData.displayName = 'Shipments.DetailDrawer.Sections.PerDiem.NoData';
